<template>
  <div class="index" v-if="data.style" :style="'position: relative;background: linear-gradient(180deg, #8BD1EF 0%, #054899 100%);background-color:'+data.style.backgroundColor">
      
  
  </div>
</template>

<script>
import config from "@/config";
export default {
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 337px;
  height: 667px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>